<template>
  <div>
    <transition name="fade" appear>
      <loader-fly v-if="!loadedInvoices"/>
    </transition>
    <div class="bb-contact-invoices">
      <div class="bb-contact-invoices-table">
        <Table :options="optionsTable" :modal-mode="true" :noDataText="noDataText"/>
      </div>
      <Pagination :data="fullInfo" :getQuery="getInvoices" :limit="defLimit" class="bb-pagination"/>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import Pagination from '@/components/Main/Pagination/Pagination'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import InvoicesApi from '@/api/Invoce/api'
import {contactFinancesTable, contactFinancesTableColumns} from '@/constants/TablesOptions/contactsFinancesTable'
import {get} from 'lodash'
import UploadFileApi from '@/api/UploadFile/api'
import clientNickname from '@/mixin/clientNickname'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'ContactInvoices',
  components: {
    Table,
    Pagination,
    ModalWindow,
    LoaderFly
  },
  mixins: [clientNickname],
  data () {
    return {
      loadedInvoices: false,
      optionsTable: contactFinancesTable,
      fullInfo: {},
      defLimit: 50,
      editableInvoice: {
        invoice: {}
      },
      crypt: true,
      file: {}
    }
  },
  computed: {
    contactsFinancesColumnsData: {
      get: function () {
        return this.$store.getters.contactsFinancesColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsFinancesColumnsData', data)
      }
    },
    contactsFinancesRowsData: {
      get: function () {
        return this.$store.getters.contactsFinancesRowsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsFinancesRowsData', data)
      }
    },
    filterByClient () {
      return `client[]=${this.clientInfo.id}` + '&isDelete[]=false'
    },
    noDataText () {
      return this.loadedInvoices ? `No over- and underpayments for ${this.nicknameClient} were found` : false
    },
    clientInfo () {
      return this.$store.getters.clientInfo
    }
  },
  methods: {
    addActions () {
      this.contactsFinancesColumnsData.forEach(item => {
        if (item.actions) {
          item.actions.getFile = this.openFile
        }
        if (item.hover && item.property === 'number') {
          item.clickAction = this.openProforma
        }
      })
    },
    getInvoices ({page}) {
      this.loadedInvoices = false
      this.contactsFinancesRowsData = []
      const filterByStatus = '&status[]=1&&status[]=3'
      let query = this.filterByClient + filterByStatus
      InvoicesApi.getInvoices({limit: this.defLimit, page, query})
        .then((resp) => {
          this.fullInfo = resp.data
          this.contactsFinancesRowsData = resp.data.invoices
          this.loadedInvoices = true
        })
        .catch(e => {
          this.loadedInvoices = true
          console.error(e)
        })
    },
    openProforma (row) {
      const id = get(row, 'id', false)
      if (!id) return
      InvoicesApi.getInvoiceById(id)
        .then(resp => {
          this.editableInvoice = {
            invoice: resp.data
          }
          this.$emit('openProforma', this.editableInvoice)
        })
        .catch(err => {
          console.error(err)
        })
    },
    openFile (file) {
      this.file.id === file.id ? saveAs(this.file.blob, this.file.label) : this.getFile(file.id)
    },
    getFile (id) {
      this.loadedInvoices = false
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.file = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loadedInvoices = true
        })
        .catch((err) => {
          console.error(err)
          this.loadedInvoices = true
        })
    }
  },
  beforeMount () {
    this.contactsFinancesColumnsData = contactFinancesTableColumns
    this.addActions()
    this.getInvoices({})
  }
}
</script>

<style lang="scss" scoped>

  .bb-contact-invoices {
    margin-right: -8px;

    &-table {
      width: 1150px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactInvoices/ContactInvoices.vue